import { render, staticRenderFns } from "./login-main-page.html?vue&type=template&id=3f64a4d6&scoped=true&external"
import script from "./login-main-page.js?vue&type=script&lang=js&external"
export * from "./login-main-page.js?vue&type=script&lang=js&external"
import style0 from "./login-main-page.scss?vue&type=style&index=0&id=3f64a4d6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64a4d6",
  null
  
)

export default component.exports